import { Injectable, OnDestroy } from '@angular/core';
import { GA4InitializeService } from './initialization/ga4-initialize.service';
import { EventQueueService } from './event-queue/event-queue.service';
import { InitializeQueueService } from './initialization/initialize-queue.service';
import { ANALYTICS_BEHAVIORAL_HUB_EVENT, BehavioralHubAnalyticsEvent } from './interface/analytics-hebavioral-hub.contract';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService implements OnDestroy {
  constructor(
    private readonly ga4InitService: GA4InitializeService,
    private readonly eventQueue: EventQueueService,
    private readonly initializeQueue: InitializeQueueService
  ) {
    // Registra callback que processa eventos enfileirados quando GA4 fica pronto
    this.initializeQueue.registrarCallback('ga4', (ctx) => {
      const sdk = this.ga4InitService.instance;
      if (sdk) {
        sdk.track(ctx);
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener(ANALYTICS_BEHAVIORAL_HUB_EVENT, this.analyticsEventHandler);
  }

  /**
   * Delega para GA4InitializeService: faz polling do DOM, configura user properties
   * e default parameters, e drena a fila de eventos. Chamar apos autenticacao.
   */
  initializeGA4(): void {
    this.listenMfeAnalyticsEvents();
    this.ga4InitService.inicializar().subscribe();
  }

  /**
   * Escuta eventos de analytics disparados pelos MFEs via CustomEvent.
   * Eventos recebidos antes do SDK estar pronto são enfileirados automaticamente.
   */
  private listenMfeAnalyticsEvents(): void {
    window.addEventListener(ANALYTICS_BEHAVIORAL_HUB_EVENT, this.analyticsEventHandler);
  }

  private readonly analyticsEventHandler = (event: Event): void => {
    const payload = (event as CustomEvent<BehavioralHubAnalyticsEvent>).detail;
    this.track(payload);
  };

  track(event: BehavioralHubAnalyticsEvent): void {
    const baseImplementationTeam = {
      implementation_team: event.analytics.parameters.implementation_team ?? environment.ga4ImplementationTeam
    };

    const payload: BehavioralHubAnalyticsEvent = {
      analytics: {
        event_name: event.analytics.event_name,
        parameters: {
          ...baseImplementationTeam,
          custom_path: event.analytics.parameters.custom_path,
          detail: event.analytics.parameters.detail
        }
      }
    };

    this.enviarEvento(payload);
  }

  private enviarEvento(payload: unknown): void {
    if (!this.ga4InitService.estaInicializado) {
      console.warn('[GA4 FILA] SDK não pronto → enfileirando:', payload);
      this.eventQueue.enqueue('ga4', payload as Record<string, unknown>);
      return;
    }

    console.info('[GA4 DIRETO] Enviando evento:', payload);
    this.ga4InitService.instance?.track(payload);
  }
}
